import classNames from 'classnames';
import { Avatar, ButtonV2, Checkbox, TooltipPortalTrigger } from 'components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './style.scss';

class StaffCard extends Component {
  static propTypes = {
    checkable: PropTypes.bool,
    checked: PropTypes.bool,
    disableCheck: PropTypes.bool,
    roleName: PropTypes.string,
    actionDisabledTooltip: PropTypes.string
  };

  static defaultProps = {
    checkable: true,
    disableCheck: false
  };

  render() {
    const {
      staff,
      onClick,
      checked,
      checkable,
      disableCheck,
      action,
      actionIcon,
      className,
      roleName,
      actionDisabledTooltip
    } = this.props;

    const cardCN = classNames(
      {
        'staff-card': true,
        'staff-card--checkable': checkable,
        'staff-card--actionable': Boolean(action)
      },
      className
    );

    return (
      <div className={cardCN} onClick={disableCheck ? undefined : onClick}>
        {checkable && <Checkbox checked={checked} disabled={disableCheck} />}
        <Avatar
          type="avatar"
          url={staff.profile_pic_url}
          name={staff.name}
          className="staff-card__avatar avatar--small"
        />
        <div className="staff-card__info">
          <div className="staff-card__full-name">{staff.name}</div>
          {roleName && <div className="staff-card__role-name">{roleName}</div>}
        </div>
        {action &&
          (actionDisabledTooltip ? (
            <TooltipPortalTrigger tooltip={actionDisabledTooltip} side="right" portalClassName="staff-card-tooltip">
              <ButtonV2 icon iconName={actionIcon} iconSize={18} disabled />
            </TooltipPortalTrigger>
          ) : (
            <ButtonV2 icon iconName={actionIcon} iconSize={18} onClick={action} />
          ))}
      </div>
    );
  }
}

export default StaffCard;
